import { useTranslation } from 'react-i18next'

import { SECTORS, type Sector } from '../data/sectors'

import { Picture } from './picture'
import { SectionEyebrow } from './section-eyebrow'

function SectorCard({ sector }: { sector: Sector }) {
  const { t } = useTranslation()
  const Icon = sector.icon

  return (
    <article className="group shadow-e2 relative aspect-[4/5] overflow-hidden rounded-lg">
      <Picture
        name={sector.image}
        alt=""
        sizes="(min-width: 1024px) 25vw, (min-width: 768px) 50vw, 100vw"
        className="absolute inset-0 size-full object-cover transition-transform duration-500 group-hover:scale-110 motion-reduce:transition-none motion-reduce:group-hover:scale-100"
      />

      {/* Navy gradient weighted to the bottom, where the copy sits. */}
      <div className="from-primary/95 via-primary/50 absolute inset-0 bg-gradient-to-t to-transparent" />

      <div className="p-stack-md absolute inset-0 flex flex-col justify-end">
        <span className="mb-stack-md bg-on-primary/20 text-on-primary flex size-12 items-center justify-center rounded-md backdrop-blur-sm">
          <Icon className="size-7" aria-hidden />
        </span>
        <h3 className="mb-stack-sm font-display text-headline-md text-on-primary">
          {t(sector.titleKey)}
        </h3>
        <p className="text-body-md text-on-primary/90">{t(sector.descriptionKey)}</p>
      </div>
    </article>
  )
}

export function SectorsSection() {
  const { t } = useTranslation()

  return (
    <section id="services" className="bg-background py-section">
      <div className="max-w-content px-margin-mobile md:px-margin-tablet lg:px-margin-desktop mx-auto">
        <header className="mb-stack-lg flex flex-col items-center text-center">
          <SectionEyebrow centered>{t('sectors.eyebrow')}</SectionEyebrow>
          <h2 className="mt-stack-sm font-display text-headline-lg text-primary">
            {t('sectors.heading')}
          </h2>
        </header>

        <div className="gap-gutter grid sm:grid-cols-2 lg:grid-cols-4">
          {SECTORS.map((sector) => (
            <SectorCard key={sector.id} sector={sector} />
          ))}
        </div>
      </div>
    </section>
  )
}
